import { LazyModule, LazyImport, registerLazyOrchestrator } from 'owa-bundling';
import {
    onPivotEnableDisableDialogSave,
    bootstrapInboxPlusPivots,
    onEasyOnTryNowClicked,
} from 'owa-mail-inbox-plus-store';
import './orchestrators/initializeInboxPlusOrchestrator';
import { logInboxPlusExperimentData } from 'owa-mail-inbox-plus-store';

const lazyModule = new LazyModule(() => import(/**/ './lazyIndex'));

export { default as initializeInboxPlus } from './actions/initializeInboxPlus';
export let lazyOnInboxPivotSelected = new LazyImport(lazyModule, m => m.onInboxPivotSelected);
export let lazyMoveRowsToInboxPlusPivot = new LazyImport(
    lazyModule,
    m => m.moveRowsToInboxPlusPivot
);

export let lazySubscribeToInboxPlusRowNotifications = new LazyImport(
    lazyModule,
    m => m.subscribeToInboxPlusRowNotifications
);

registerLazyOrchestrator(
    onPivotEnableDisableDialogSave,
    lazyModule,
    m => m.changeTableViewOnDialogSave
);

registerLazyOrchestrator(
    onPivotEnableDisableDialogSave,
    lazyModule,
    m => m.updateUserConfigValuesOnDialogSave
);

registerLazyOrchestrator(
    bootstrapInboxPlusPivots,
    lazyModule,
    m => m.updateUserConfigValuesOnBootstrap
);

registerLazyOrchestrator(
    logInboxPlusExperimentData,
    lazyModule,
    m => m.logIsFocusedOtherUserOrchestrator
);

registerLazyOrchestrator(
    logInboxPlusExperimentData,
    lazyModule,
    m => m.logTabContentsSizeOrchestrator
);

registerLazyOrchestrator(
    onEasyOnTryNowClicked,
    lazyModule,
    m => m.updateUserConfigValuesOnEasyOnClicked
);
